import { Mail, Phone, Users } from "lucide-react";
import { Badge } from "@/components/ui/Badge";
import type { OrderGrantedStaff } from "../types";

interface Props {
  staff: OrderGrantedStaff[] | undefined;
}

/**
 * Pracownicy GK ELEKTIM z nadanym dostępem do zamówienia innym niż „Podgląd”
 * (Zarządzanie / Realizacja) — osobna sekcja POD zamawiającym, obok karty
 * podwykonawcy, po obu stronach (karta GK i strona podwykonawcy). Osób może być
 * kilka; kontakt każdej pochodzi na żywo z jej profilu. Sekcja znika, gdy nikt
 * takiego dostępu nie ma.
 */
export function OrderGrantedStaffCard({ staff }: Props) {
  if (!staff || staff.length === 0) return null;
  return (
    <div className="bg-white dark:bg-gray-800 p-4 border-l-4 border-[var(--color-primary)]/40" data-testid="order-granted-staff">
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2 flex items-center gap-1.5">
        <Users size={13} className="shrink-0" />
        Pracownicy GK ELEKTIM z dostępem do zamówienia
      </p>
      <ul className="flex flex-col gap-3">
        {staff.map((person) => (
          <li key={person.id}>
            <p className="text-sm font-medium text-gray-900 dark:text-gray-100 break-words flex items-center gap-2 flex-wrap">
              {person.full_name}
              <Badge color={person.access_type === "manage" ? "blue" : "orange"}>{person.access_type_label}</Badge>
            </p>
            <div className="mt-1 flex flex-col gap-0.5 text-sm">
              <span className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                <Phone size={13} className="shrink-0" />
                {person.phone ? (
                  <a href={`tel:${person.phone}`} className="hover:underline break-all">{person.phone}</a>
                ) : (
                  <span className="text-gray-400 dark:text-gray-500">brak numeru</span>
                )}
              </span>
              <span className="flex items-center gap-1.5 text-gray-600 dark:text-gray-400">
                <Mail size={13} className="shrink-0" />
                {person.email ? (
                  <a href={`mailto:${person.email}`} className="hover:underline break-all">{person.email}</a>
                ) : (
                  <span className="text-gray-400 dark:text-gray-500">brak adresu</span>
                )}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
